export const AuditStatus = {
  UNAUDITED: 'unaudited',
  AUDITED: 'audited',
  UNAVAILABLE: 'unavailable',
};

export type AuditStatus = (typeof AuditStatus)[keyof typeof AuditStatus];

export const AuditUnavailableReason = {
  NOT_FOUND: 'trailerNotFound',
  AT_SHOP: 'trailerAtShop',
  OTHER: 'other',
};

export type AuditUnavailableReason = (typeof AuditUnavailableReason)[keyof typeof AuditUnavailableReason];
